import { useState, useEffect } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    TextField,
    Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import auth from "../route_rules/auth";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { GridApi, GridCellValue, GridColDef } from '@mui/x-data-grid';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import ConfirmDialog, { confirmDialog } from "../components/ConfirmDialog";
import { ICrew } from "../interfaces/ICrew";
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';
import MuiInput from '@mui/material/Input';
import { IApplication } from "../interfaces/IApplication";
import { setPageTitle } from "../slices/applicationSlice";
import { useAppDispatch } from "../hooks";
import FilledInput from '@mui/material/FilledInput';
import ListItemText from '@mui/material/ListItemText';
import ScanIcon from '@mui/icons-material/QrCodeScanner';
import { IUser } from "../interfaces/IUser";
import { IBench } from "../interfaces/IBench";
import { IZone } from "../interfaces/IZone";
import { IBay } from "../interfaces/IBay";
import { IGreenhouse } from "../interfaces/IGreenhouse";
import { IPatchingList, IPatchingLists } from "../interfaces/Patching/IPatchingList";
import { IPatchingSearchChips } from "../interfaces/Patching/IPatchingSearchChips";
import { IWorkLog, IWorkLogs } from "../interfaces/Patching/IWorkLog";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const Input = styled(MuiInput)`
  width: 42px;
`;

const label = { inputProps: { 'aria-label': 'Checkbox' } }

const handleSubmitD = () => console.log('Okay')

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[300],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2, }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
}));



interface ITray {
    id: number,
    description: string,
    benchId: number,
    Species: string,
    Variety: string,
    Color: string,
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function PatchingCombifix() {

    const dispatch = useAppDispatch();
    const { state } = useLocation();

    useEffect(() => {
        let appState: IApplication = {
            pageTitle: "Patching Combifix",
            backgroundPath: "/assets/images/patchingbg.jpg"
        }
        dispatch(setPageTitle(appState));

        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Users`)
            .then(res => {
                console.log("COMPLETE", res.data);
                setUsers(res.data);
            });

        GetPatchingLists();
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
            .then(res => {
                setCrews(res.data);
            })

        if (state) {
            if (state.patchingList) {
                setSelectedPatchingList(state.patchingList);
                if (state.patchingList.crew) {
                    setSelectedCrew(state.patchingList.crew);
                }
            }
        }
    }, []);

    const [value, setPercent] = React.useState<number | string | Array<number | string>>(
        30,
    );

    const handleSliderChange = (event: Event, newPercent: number | number[]) => {
        setPercent(newPercent);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPercent(event.target.value === '' ? '' : Number(event.target.value));
    };


    const [errorMessage, setErrorMessage] = useState({ error: "" });
    const [workLogs, setWorkLogs] = useState<IWorkLogs>([]);
    const [completeRows, setCompleteRows] = useState<IWorkLogs>([]);
    const [customValue, customSetValue] = React.useState(0);
    const [users, setUsers] = React.useState<IUser[]>([]);
    const [tray, setTray] = React.useState<ITray>();
    const [bench, setBench] = React.useState<IBench>();
    const [zone, setZone] = React.useState<IZone>();
    const [bay, setBay] = React.useState<IBay>();
    const [greenhouse, setGreenhouse] = React.useState<IGreenhouse>();
    const [workLog, setWorkLog] = React.useState<IWorkLog>();

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 130, hide: true },
        { field: 'material', headerName: 'Material', width: 130 },
        { field: 'location', headerName: 'Location', width: 200, },
        { field: 'traySize', headerName: 'Size', width: 75 },
        { field: 'species', headerName: 'Species', width: 130 },
        { field: 'variety', headerName: 'Variety', width: 130 },
        { field: 'color', headerName: 'Color', width: 130 },
        {
            field: 'complete', headerName: 'Complete', width: 130, renderCell: (params) => {
                return params.value ? (
                    <CheckCircleIcon
                    />
                ) : (
                    <CloseIcon
                    />
                );
            }
        },
        {
            field: "action",
            headerName: "Action",
            width: 300,
            sortable: false,
            renderCell: (params) => {

                const markOffWorkLog = (e: any) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellValue> = {};

                    api
                        .getAllColumns()
                        .filter((c) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
                        );
                };

                const completeWorkLog = (e: any) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellValue> = {};

                    api
                        .getAllColumns()
                        .filter((c) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
                        );

                    console.log("THIS ROW", thisRow);
                    let workLog = workLogs.find(x => x.id == thisRow.id);
                    console.log("WORK LOG", workLog)
                    if (workLog) {
                        workLog.complete = true;
                        axios.put<IWorkLog>(`${process.env.REACT_APP_ENDPOINT}/api/WorkLogs/${thisRow['id']}`,
                            workLog
                        ).then((x) => {
                            loadWorkLogs();
                        })

                    }


                };

                return <Grid xs={12}>
                    <Grid item xs={2}>
                        <Button variant="contained" color="primary" onClick={markOffWorkLog}>MARK OFF</Button>
                        <Button sx={{ marginLeft: 1 }} variant="contained" color="secondary" onClick={completeWorkLog}>Complete</Button>
                    </Grid>
                </Grid>
            }
        },
    ];

    useEffect(() => {
        loadWorkLogs();
    }, []);



    const loadWorkLogs = () => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/WorkLogs`)
            .then(res => {
                setWorkLogs(res.data);
            });
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        customSetValue(newValue);
    };
    let items = [];
    let history = useNavigate();
    const validate = (values: { password: any; email: string }) => {
        const errors = { password: "", email: "" };

        if (!values.password) {
            errors.password = "This password field is required";
        }

        if (!values.email) {
            errors.email = "This email field is Required";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
            errors.email = "Please input a valid email";
        }

        return errors;
    };
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validate,
        onSubmit: (values) => {
            console.log(values);

            axios
                .post("shared/auth/user/login", {
                    email: formik.values.email,
                    password: formik.values.password,
                })
                .then((response) => {
                    console.log(response);
                    let loginToken = response.data.access_token;
                    localStorage.setItem("token", JSON.stringify(loginToken));

                    auth.login(() => {
                        history("/dashboard");
                    });
                })
                .catch((error) => {
                    if (error.response !== undefined) {
                        console.log(error.response);
                        setErrorMessage(error.response.data);
                    }
                });
        },
    });

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: 0,
        borderRadius: 0,
        boxShadow: "none",

    }));

    const handleDelete = (props: IUser) => {
        var users = selectedUsers.filter(obj => {
            return obj.id != props.id
        });
        setSelectedUsers(users);
    };

    const [open, setOpen] = React.useState(false);
    const [markOffOpen, setMarkOffOpen] = React.useState(false);
    const [submitOpen, setSubmitOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitOpen = () => {
        setSubmitOpen(true);
    };

    const handleSubmitClose = () => {
        setSubmitOpen(false);
    };

    const handleMarkoffClose = () => {
        setMarkOffOpen(false);
    };

    interface IFormInput {
        Id: number,
        Name: string,
        User: IUser,
        Crew: ICrew,
        Barcode: string,
        description: string,
        benchName: string,
        zoneName: string,
        bayName: string,
        greenhouseName: string,
    }



    const { register, handleSubmit, control, formState: { errors }, getValues, setValue } = useForm<IFormInput>(
        {
            defaultValues: {
                description: ""
            }
        }
    );
    const onSubmit: SubmitHandler<IFormInput> = data => {
        console.log(data);
        axios.put(`${process.env.REACT_APP_ENDPOINT}/api/WorkLogs/${tray?.id}`, {
            id: tray?.id,
        })
        loadWorkLogs();
    };
    const LoadTrayData = () => {
        let barcode = getValues("Barcode");
        console.log("BARCODE", barcode);
        if (barcode) {
            axios
                .get(`${process.env.REACT_APP_ENDPOINT}/api/Trays/Search/${barcode}`)
                .then(res => {
                    console.log("TRAY", res.data);
                    setTray(res.data);
                    setValue('description', res.data?.description!);
                });
        }
    }

    React.useLayoutEffect(() => {
        if (tray) {
            axios
                .get(`${process.env.REACT_APP_ENDPOINT}/api/Benches/${tray?.benchId}`)
                .then(res => {
                    console.log("BENCH", res.data);
                    setBench(res.data);
                    setValue('benchName', res.data?.name!);
                });
        }
    }, [tray])

    React.useLayoutEffect(() => {
        if (bench) {
            axios
                .get(`${process.env.REACT_APP_ENDPOINT}/api/Zones/${bench.zoneID}`)
                .then(res => {
                    console.log("Zone", res.data);
                    setZone(res.data);
                    setValue('zoneName', res.data?.name!);
                });
        }

    }, [bench])

    React.useLayoutEffect(() => {
        if (zone) {
            axios
                .get(`${process.env.REACT_APP_ENDPOINT}/api/Bays/${zone.bayID}`)
                .then(res => {
                    console.log("Bay", res.data);
                    setBay(res.data);
                    setValue('bayName', res.data?.name!);
                });
        }

    }, [zone])

    React.useLayoutEffect(() => {
        if (bay) {
            axios
                .get(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/${bay?.greenhouseID}`)
                .then(res => {
                    console.log("Greenhouse", res.data);
                    setGreenhouse(res.data);
                    setValue('greenhouseName', res.data?.name!);
                });
        }

    }, [bay])

    const OpenMarkoffDialog = (props: boolean) => {
        setMarkOffOpen(props);
    }

    const FinalizeBatch = () => {
        // axios
        //     .get(`https://localhost:44324/api/Trays/Search/${barcode}`)
        //     .then(res => {
        //         setTray(res.data);
        //         setValue('description', tray?.description!);
        //         console.log(tray?.benchId);
        //         axios
        //             .get(`https://localhost:44324/api/Benches/${tray?.benchId}`)
        //             .then(res => {
        //                 console.log("BENCH", res.data);
        //                 setBench(res.data);
        //                 setValue('benchName', bench?.name!);
        //             });
        //     });
    }


    const [selectedCrew, setSelectedCrew] = useState<ICrew>();
    const [crews, setCrews] = useState<ICrew[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<IUser[]>([]);
    const [selectedUser, setSelectedUser] = useState<IUser>();
    const [searchInformation, setSearchInformation] = React.useState<IPatchingSearchChips>({ year: 2023, weeks: [], generation: '', traySize: '' });

    const GetPatchingLists = () => {
        if (searchInformation) {
            axios
                .post(`${process.env.REACT_APP_ENDPOINT}/api/PatchingLists/search`, searchInformation)
                .then(res => {
                    console.log("RESPONSE", res);
                    setPatchingLists(res.data);
                })
        }
    }

    useEffect(() => {
        console.log("Selected Crew Changed");
        if (selectedCrew) {
            var users = selectedCrew.userCrews.map(obj => {
                return obj.user!
            });
            if (users) {
                setSelectedUsers(users);
            }
        }
    }, [selectedCrew])

    const [personName, setPersonName] = React.useState<string[]>([]);

    const handleMemberChange = (event: SelectChangeEvent<typeof personName>) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const [percentcomplete, setPercentComplete] = React.useState('');

    const handlePercentComplete = (event: SelectChangeEvent) => {
        setPercentComplete(event.target.value as string);
    };

    const [patchingLists, setPatchingLists] = useState<IPatchingLists>([]);
    const [selectedPatchingList, setSelectedPatchingList] = useState<IPatchingList>();

    return (
        <Box component="form" onSubmit={handleSubmit(onSubmit)} padding={0}>
            <Grid container spacing={0} xs={12}>
                <Grid item xs={4}>
                    <Item sx={{ bgcolor: 'rgba(255, 255, 255, 0.85)', height: '100%' }}>
                        <Grid item xs={12}>
                            <Item>
                                <Autocomplete
                                    value={selectedPatchingList}
                                    options={patchingLists}
                                    getOptionLabel={(option) => `${option.id}: ${option.name}`}
                                    onChange={(_, data) => {
                                        setSelectedPatchingList(data!);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Patching Lists"></TextField>
                                    )}
                                />
                            </Item>
                        </Grid>
                        <Grid container spacing={1} padding={1}>
                            <Grid item xs={6}>
                                <Item sx={{ bgcolor: 'transparent' }}>
                                    <Controller
                                        control={control}
                                        name="Crew"
                                        render={({ field: { ref, onChange, ...field } }) => (
                                            <Autocomplete
                                                value={selectedCrew}
                                                options={crews}
                                                getOptionLabel={(option) => `${option.id}: ${option.name}`}
                                                onChange={(_, data) => {
                                                    setSelectedCrew(data!);
                                                    return onChange(data);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} {...field} inputRef={ref} variant="outlined" label="Select a Crew"></TextField>
                                                )}
                                            />
                                        )}
                                    />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl sx={{ width: '100%', my: 1, mr: 4 }}>
                                    <InputLabel id="demo-multiple-checkbox-label">Add Employees</InputLabel>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        value={personName}
                                        onChange={handleMemberChange}
                                        input={<FilledInput />}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}
                                        sx={{ textAlign: "left" }}
                                    >
                                        {users.map((user) => (
                                            <MenuItem key={user.id} value={`${user.firstName} ${user.lastName}`}>
                                                {/* <Checkbox checked={users.indexOf(user) > -1} /> */}
                                                <ListItemText primary={`${user.firstName} ${user.lastName}`} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/*   <Grid item xs={12} sx={{ marginBottom: 1, marginTop: 0 }}>
                                <Item sx={{ bgcolor: 'transparent' }}>
                                    <Stack direction="row" spacing={1}>
                                        {selectedUsers.map(obj => {
                                            return <Chip label={`${obj.firstName} ${obj.lastName}`} color="primary" onDelete={() => handleDelete(obj)} />
                                        })}
                                        
                                    </Stack>
                                </Item>
                            </Grid> */}
                            <Grid item xs={12} sx={{ marginY: 1 }}></Grid>
                            <Grid item xs={8} sx={{ marginBottom: 1 }}>
                                <Item sx={{ bgcolor: 'transparent' }}>
                                    <TextField required variant="outlined" fullWidth id="barcode" label="Barcode" color='primary' {...register("Barcode")} />
                                </Item>
                            </Grid>
                            <Grid item xs={4} sx={{ marginBottom: 1 }}>
                                <Item sx={{ bgcolor: 'transparent' }}>
                                    <Button variant="contained" endIcon={<ScanIcon sx={{ width: 40, height: 40, color: "#FFF" }} />} color="success" fullWidth size="large" onClick={() => LoadTrayData()} sx={{ height: "60px" }}>
                                        <Typography variant="h5" fontWeight={600}>SCAN</Typography></Button>
                                </Item>
                            </Grid>
                            <Grid item xs={12} sx={{ mb: 1 }}></Grid>
                            <Grid item xs={12} sx={{ marginY: 2 }}></Grid>
                            <Grid item xs={12}>
                                <Item sx={{ bgcolor: 'transparent' }}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        sx={{ p: 2 }}
                                        size="large"
                                        onClick={handleSubmitOpen}
                                        endIcon={<CheckCircleIcon sx={{ width: 40, height: 40, color: "#FFF" }} />}
                                    >
                                        <Typography variant="h5" fontWeight={600}>
                                            Submit
                                        </Typography>
                                    </Button>
                                </Item>
                            </Grid>
                        </Grid>
                    </Item>
                </Grid>
                <Grid item xs={8} padding={0}>
                    <Grid item xs={12}>
                        <Item>
                            <Box sx={{ width: '100%', height: '50%', padding: '0' }}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={customValue} onChange={handleChange} textColor="secondary" indicatorColor="secondary" >
                                        <Tab label="Work Log" {...a11yProps(0)} icon={<ListAltIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '900', letterSpacing: '0' }} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={customValue} index={0}  >
                                    <div style={{ height: 'calc(100vh - 197px)', width: '100%' }}>
                                        <StripedDataGrid
                                            rows={workLogs}
                                            columns={columns}
                                            pageSize={20}
                                            rowsPerPageOptions={[20]}
                                            sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                                            getRowClassName={(params) =>
                                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                            }
                                        />
                                    </div>
                                </TabPanel>
                            </Box>
                        </Item>
                    </Grid>

                </Grid>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Add Employee</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Typography sx={{ mb: 3 }}>Please select the employee you would like to add.</Typography>
                        </DialogContentText>
                        <Controller
                            control={control}
                            name="User"
                            render={({ field: { ref, onChange, ...field } }) => (
                                <Autocomplete
                                    options={users}
                                    getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                                    onChange={(_, data) => {
                                        return onChange(data?.id);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} {...field} fullWidth inputRef={ref} variant="outlined" label="Users"></TextField>
                                    )}
                                />
                            )}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button color="success" variant="contained" onClick={handleClose}>Add Employee</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={markOffOpen} onClose={handleMarkoffClose}>
                    <DialogTitle><Typography variant="h5" align="center">How much of the final tray is remaining?</Typography></DialogTitle>
                    <DialogContent>
                        <Grid container spacing={1} maxHeight='calc(100vh - 60px)'>
                            <Grid item xs={3}>
                                <Button variant="contained" color="primary" fullWidth>25%</Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button variant="contained" color="secondary" fullWidth>50%</Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button variant="contained" color="secondary" fullWidth>75%</Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button variant="contained" color="success" fullWidth>100%</Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Item>
                                    <FormControlLabel
                                        value=""
                                        control={<Checkbox />}
                                        label="Is the final tray being thrown away?"
                                        labelPlacement="start"
                                    />
                                </Item>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleMarkoffClose}>Cancel</Button>
                        <Button color="success" variant="contained" onClick={() => { FinalizeBatch() }}>Finalize Batch</Button>
                    </DialogActions>
                </Dialog>
            </Grid>

            <BootstrapDialog
                onClose={handleSubmitClose}
                aria-labelledby="customized-dialog-title"
                open={submitOpen}
                maxWidth='sm'
                fullWidth
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleSubmitClose}>
                    Final Tray Review
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container>
                            <Grid item xs={12}>
                                <FormControlLabel control={<Checkbox defaultChecked />} label="Discard Final Tray" labelPlacement='start' sx={{ '& .MuiSvgIcon-root': { fontSize: 40 } }} />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Percent Complete</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={percentcomplete}
                                        label="Percent Complete"
                                        onChange={handlePercentComplete}
                                    >
                                        <MenuItem value={25}>25%</MenuItem>
                                        <MenuItem value={50}>50%</MenuItem>
                                        <MenuItem value={75}>75%</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <DialogActions>
                            <Button size="large" variant="outlined" onClick={handleSubmitClose}>Cancel</Button>
                            <Button size="large" color="success" variant="contained" onClick={() => confirmDialog("Are you sure you want to add this record?", handleSubmit(onSubmit))} autoFocus>
                                Submit
                            </Button>
                        </DialogActions>
                        <ConfirmDialog />
                    </Box>
                </DialogContent>
            </BootstrapDialog>


        </Box>
    );
}